import { createInertiaApp } from '@inertiajs/react'
import '../styles/application.css'

// `pages` is transformed by @inertiajs/vite into a proper resolve() at build time
createInertiaApp({
  pages: '../pages',
}).catch((error) => {
  if (document.getElementById('app')) {
    throw error
  }
})
